<template>
  <div>
    <div class="section-fourth">
      <div class="section-bg">
        <img src="@/assets/images/banner_4.jpg" alt />
      </div>
      <div class="title">
        <img src="@/assets/images/text_hzlh.png" alt="">
      </div>
      <div class="copyright">
        <a class="copy" href='http://beian.miit.gov.cn'>备案编号：粤ICP备19150625号-1 copyright@2018 格局云（广州）信息科技有限公司</a>
      </div>
       <!-- <div class='sectionTwo'>第四屏内容</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionFoot"
};
</script>

<style lang="css" scoped>
.section-fourth{
  width:100%;
  height:100%;
  display:flex;
  justify-content: center;
  z-index:10;
  overflow:hidden;
}
.section-bg{
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index:0;
  cursor:pointer;
}
.section-bg img{
  width:100%;
  height:100%;
}
.title{
  width: 100%;
  height:126px;
  position:absolute;
  left:0;
  top:110px;
  display:flex;
  justify-content: center;
}
.title img{
  width:487px;
  height:100%;
  position: absolute;
  /* transition: opacity 1s bottom 2s; */
  bottom: -999px;
  opacity: 0;
  overflow:hidden;
}
.title.current img{
  animation: myFourth 2s;
  animation-fill-mode:forwards;
}
@keyframes myFourth {
  form {
    bottom: -999px;
    opacity: 0;
  }
  /* 50%{
    bottom: -555px;
    opacity: .5;
  } */
  to {
    bottom: 0px;
    opacity: 1;
  }
}
.copyright{
  width:100%;
  height:20px;
  position:absolute;
  bottom:2.6%;
  left: 0;
  display:flex;
  justify-content: center;
  align-items:center;
}
.copyright .copy{
  letter-spacing:1.6px;
  font-size:14px;
  color: rgba(255, 255, 255, 0.5);
}
.sectionTwo{
  position:absolute;
  top:50%;
  left: 50%;
  transform: translate(-50%,-50%);
  font-size:50px;
  color:#f00;
  opacity: 0.2;
  transition: color 1s opacity 1s;
  z-index: 1111;
}
.sectionTwo.current {
  font-size:100px;
  color:#0f0;
  opacity:1;
}
</style>
